export default __webpack_public_path__ + "static/media/member-alex.dae57726.jpg";